<template>
    <div class="streak-content-container text-white">
        <div class="close-button"
             @click="navigationStore.showMobileStreak = false">
            &times;
        </div>
        <div class="streak-card-container">
            <StreakCard />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useNavigationStore } from '@/js/store/quests/dashboard/NavigationStore';
    import StreakCard from '../streak/StreakCard.vue';
    import { useModalActive } from '@/js/composables/useModalActive';

    const navigationStore = useNavigationStore();

    useModalActive();
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/missions-partials/z-index" as missionsZIndex;
@use "@/sass/design-system/variables" as variables;

.streak-content-container {
    position: fixed;
    z-index: missionsZIndex.$mobile-notifications-container-z-index;
    top: 0;
    right: 0;
    left: 0;
    overflow: hidden;
    height: 100vh;
    background: variables.$baseWhite;

    .close-button {
        display: flex;
        height: 40px;
        justify-content: flex-end;
        padding-right: 16px;
        background: legacyVariables.$tippy-mobile-background;
        color: legacyVariables.$light-grey-blue;
        cursor: pointer;
        font-size: 40px;
        line-height: 1;
        transition: color 200ms ease;

        &:hover {
            color: variables.$baseWhite;
        }
    }

    .streak-card-container {
        display: flex;
        justify-content: center;

        p {
            font-size: 12px;
        }
    }
}
</style>
